// This file is auto-generated by @hey-api/openapi-ts

import type { RequestResult } from '../client';
import { client } from '../client.gen';
import type { Options } from '../sdk.gen';
import type { ExtractPageVideoUsingPostData, ExtractPageVideoUsingPostErrors, ExtractPageVideoUsingPostResponses, ExtractSearchVideoUsingPostData, ExtractSearchVideoUsingPostErrors, ExtractSearchVideoUsingPostResponses, ExtractVideoTkUsingPostData, ExtractVideoTkUsingPostErrors, ExtractVideoTkUsingPostResponses, ExtractVideoUsingPostData, ExtractVideoUsingPostErrors, ExtractVideoUsingPostResponses, SetInterceptAgentUsingPostData, SetInterceptAgentUsingPostErrors, SetInterceptAgentUsingPostResponses } from '../types.gen';

export class ExtractFreeControllerService {
    /**
     * setInterceptAgent
     */
    public static setInterceptAgentUsingPost<ThrowOnError extends boolean = false>(options?: Options<SetInterceptAgentUsingPostData, ThrowOnError>): RequestResult<SetInterceptAgentUsingPostResponses, SetInterceptAgentUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<SetInterceptAgentUsingPostResponses, SetInterceptAgentUsingPostErrors, ThrowOnError>({
            url: '/v1/extract/free/agent',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * extractVideo
     */
    public static extractVideoUsingPost<ThrowOnError extends boolean = false>(options?: Options<ExtractVideoUsingPostData, ThrowOnError>): RequestResult<ExtractVideoUsingPostResponses, ExtractVideoUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<ExtractVideoUsingPostResponses, ExtractVideoUsingPostErrors, ThrowOnError>({
            url: '/v1/extract/free/video',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * extractPageVideo
     */
    public static extractPageVideoUsingPost<ThrowOnError extends boolean = false>(options?: Options<ExtractPageVideoUsingPostData, ThrowOnError>): RequestResult<ExtractPageVideoUsingPostResponses, ExtractPageVideoUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<ExtractPageVideoUsingPostResponses, ExtractPageVideoUsingPostErrors, ThrowOnError>({
            url: '/v1/extract/free/video-page',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * extractSearchVideo
     */
    public static extractSearchVideoUsingPost<ThrowOnError extends boolean = false>(options?: Options<ExtractSearchVideoUsingPostData, ThrowOnError>): RequestResult<ExtractSearchVideoUsingPostResponses, ExtractSearchVideoUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<ExtractSearchVideoUsingPostResponses, ExtractSearchVideoUsingPostErrors, ThrowOnError>({
            url: '/v1/extract/free/video-search',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * extractVideoTk
     */
    public static extractVideoTkUsingPost<ThrowOnError extends boolean = false>(options?: Options<ExtractVideoTkUsingPostData, ThrowOnError>): RequestResult<ExtractVideoTkUsingPostResponses, ExtractVideoTkUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<ExtractVideoTkUsingPostResponses, ExtractVideoTkUsingPostErrors, ThrowOnError>({
            url: '/v1/extract/free/video/tk',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
}
